module.exports = __webpack_public_path__ + "img/app_main2_new.67c58bf5.png";